import React, { useEffect, useState } from 'react';
import {
  IHistoryConstituent,
  useGetHistoryConstituentsByIndexLazyQuery
} from '../../../../generated/graphql';
import { sumWeightPercentageCalculation, weightCalculation } from '../../../../utils/mathUtils';
import { FormatTableData, renderDate } from '../../../../utils/styleUtils';
import { IHeadCell } from '../../../Common/Tables/OverviewTable';
import moment from 'moment-timezone';
import { Box } from '@mui/material';
import PaperCard from '../../../Common/Layout/PaperCard';
import DenseTable from '../../../Common/Tables/DenseTable';
import { Colors } from '../../../../utils/theme';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import EpraDatePicker from '../../../Common/Fields/EpraDatePicker';
import InputComponent from '../../../Common/Fields/InputComponent';
import DialogBox from '../../../Common/Layout/DialogBox';

type IProps = {
  handleClose: () => void;
  indexId: string;
};

const ConstituentsForm: React.FunctionComponent<IProps> = ({ handleClose, indexId }: IProps) => {
  const [date, setDate] = useState<Date | null>(null);
  const [numberOfRecords, setNumberOfRecords] = useState<number>();
  const [sumWeight, setSumWeight] = useState<number>();
  const [sumWeightPerc, setSumWeightPerc] = useState<number>();
  const [getIndex, { data, loading }] = useGetHistoryConstituentsByIndexLazyQuery({
    fetchPolicy: 'no-cache'
  });
  useEffect(() => {
    getIndex({
      variables: {
        index_id: parseInt(indexId)
      }
    });
  }, []);

  useEffect(() => {
    getIndex({
      variables: {
        index_id: parseInt(indexId),
        date: date ? moment(date).format('YYYY-MM-DD') : null
      }
    });
  }, [date]);

  useEffect(() => {
    if (data && data.result) {
      setNumberOfRecords(data.result.length);
      setSumWeight(weightCalculation(data.result as IHistoryConstituent[]));
      setSumWeightPerc(sumWeightPercentageCalculation(data.result as IHistoryConstituent[]));
    }
  }, [data]);

  const columns = [
    {
      title: 'Date day',
      width: 175,
      type: 'date',
      field: 'date',
      render: (rowData: IHistoryConstituent) => renderDate(rowData.date)
    },
    {
      title: 'Full mkt cap',
      width: 121,
      type: 'numeric',
      field: 'stock.historyStock.engl_mkt_cap'
    },
    {
      title: 'Free float mkt cap',
      width: 152,
      type: 'numeric',
      field: 'stock.historyStock.free_float_market_cap'
    },
    { title: 'Stock Name', width: 546, field: 'stock.name' },
    { title: 'Weight Perc', width: 229, type: 'numeric', field: 'weight_perc' },
    { title: 'Weighting', width: 178, type: 'numeric', field: 'weighting' }
  ] as IHeadCell[];

  return (
    <DialogBox id="new-index" width={1400} title="" onClose={handleClose}>
      <Box className="centralize" sx={{ width: '100%', paddingTop: '80px' }}>
        <PaperCard headerText="Constituents" width="82%" additionalStyle={{ height: '680px' }}>
          <Box
            sx={{
              width: '100%',
              paddingTop: '20px',
              paddingBottom: '20px',
              paddingLeft: '20px',
              background: Colors.lightBlue,
              display: 'grid',
              gridTemplateColumns: 'repeat(8, minmax(0, 1fr))',
              gap: '42px 25px'
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <EpraDatePicker
                id="index-constituents-date-picker"
                label="Date"
                value={date}
                onChange={(value) => setDate(value)}
                disabled={false}
                sx={{
                  background: Colors.white,
                  gridColumn: 'span 1'
                }}
              />
            </LocalizationProvider>
            {/* {<span style={{ gridColumn: 'span 0', borderRight: '3px solid' + Colors.white }}></span>} */}
            <InputComponent
              id="index-constituents-records-number-of-records"
              label="Records"
              value={numberOfRecords || ''}
              disabled={true}
              additionalStyle={{
                gridColumn: 'span 1',
                background: Colors.white
              }}
            />
            <InputComponent
              id="index-constituents-sum-weight"
              label="Sum weight"
              value={Number(sumWeight)}
              disabled={true}
              additionalStyle={{
                gridColumn: 'span 1',
                background: Colors.white
              }}
            />
            <InputComponent
              id="index-constituents-sum-weight-percentage"
              label="Sum weight %"
              value={sumWeightPerc || ''}
              disabled={true}
              additionalStyle={{ gridColumn: 'span 1', background: Colors.white }}
            />
          </Box>
          <DenseTable
            columns={columns}
            data={FormatTableData(data?.result || [])}
            loading={loading}
            handleDetails={() => true}
            handleRemove={() => true}
            pageSize={10}
            crudType={''}
            additionalToolbar={true}
            fixedHeaders={true}
          />
        </PaperCard>
      </Box>
    </DialogBox>
  );
};
export default ConstituentsForm;
